import claimModel from "./claim";
import lapseModel from "./lapse";
import ticketModel from "./ticket";

const driverModel = {
    brth:{
        type:"text",
        title: "Age",
        propertyName:"age",
        min: 18,
        max: 99,
        middleware: "crmRecordMiddleware",
        validators: ["required","mustBeNumeric","min","max"],
        mask: Number,
        value:"" // 19980118
    },
    gend:{
        type:"select",
        title: "Gender",
        propertyName:"gender",
        middleware: "crmRecordMiddleware",
        validators: ["required"],
        options: [{name:"Male",value:"M"},{name:"Female",value:"F"}],
        value:"" // M
    },
    mrst:{
        type:"select",
        title: "Martial Status",
        propertyName:"martial_status",
        middleware: "crmRecordMiddleware",
        validators: ["required"],
        options: [{name:"Single",value:"S"},{name:"Married",value:"M"}],
        value:"" // S
    },
    mtat:{
        type:"hidden",
        value:"N"
    },
    pssd:{
        type:"hidden",
        value:"N"
    },
    rtap:{
        type:"hidden",
        value:"Applicant"
    },
    reti:{
        type:"hidden",
        value:"N"
    },
    drtr:{
        type:"hidden",
        value:"N"
    },
    dtci:{
        type:"select",
        title: "Years Insured",
        propertyName:"years_insured",
        middleware: "crmRecordMiddleware",
        validators: ["required"],
        options: [{name:"0 years",value:"0"},{name:"1 years",value:"1"},{name:"2 years",value:"2"},{name:"3 years",value:"3"},{name:"4 years",value:"4"},{name:"5 years",value:"5"},{name:"6 years",value:"6"},{name:"7 years",value:"7"},{name:"8 years",value:"8"},{name:"9 years",value:"9"},{name:"10 years",value:"10"},{name:"11 years",value:"11"},{name:"12 years",value:"12"},{name:"13 years",value:"13"},{name:"14 years",value:"14"},{name:"15 years",value:"15"},{name:"16 years",value:"16"},{name:"17 years",value:"17"},{name:"18 years",value:"18"},{name:"19 years",value:"19"},{name:"20 years",value:"20"},{name:"21 years",value:"21"},{name:"22 years",value:"22"},{name:"23 years",value:"23"},{name:"24 years",value:"24"},{name:"25 years",value:"25"},{name:"26 years",value:"26"},{name:"27 years",value:"27"},{name:"28 years",value:"28"},{name:"29 years",value:"29"},{name:"30 years",value:"30"},{name:"31 years",value:"31"},{name:"32 years",value:"32"},{name:"33 years",value:"33"},{name:"34 years",value:"34"},{name:"35 years",value:"35"},{name:"36 years",value:"36"},{name:"37 years",value:"37"},{name:"38 years",value:"38"},{name:"39 years",value:"39"},{name:"40 years",value:"40"},{name:"41 years",value:"41"},{name:"42 years",value:"42"},{name:"43 years",value:"43"},{name:"44 years",value:"44"},{name:"45 years",value:"45"},{name:"46 years",value:"46"},{name:"47 years",value:"47"},{name:"48 years",value:"48"},{name:"49 years",value:"49"},{name:"50 years",value:"50"},{name:"51 years",value:"51"},{name:"52 years",value:"52"},{name:"53 years",value:"53"},{name:"54 years",value:"54"},{name:"55 years",value:"55"},{name:"56 years",value:"56"},{name:"57 years",value:"57"},{name:"58 years",value:"58"},{name:"59 years",value:"59"},{name:"60 years",value:"60"}],
        value:"" // 20110118
    },
    drli:{
        type:"select",
        title: "Current License Class",
        propertyName:"current_license_class",
        middleware: "crmRecordMiddleware",
        validators: ["required"],
        options: [{name:"G - Full License",value:"G"},{name:"G2 - Intermediate License",value:"G2"}],
        value:"" // G
    },
    cdrl:{
        type:"hidden",
        title: "License Class",
        propertyName:"current_license_class",
        middleware: "crmRecordMiddleware",
        validators: ["required"],
        options: [{name:"Commercial license Class A",value:"A"},{name:"Commercial license Class A with condition (R)",value:"AR"},{name:"Commercial license Class B",value:"B"},{name:"Commercial license Class C",value:"C"},{name:"Commercial license Class D",value:"D"},{name:"Commercial license Class E",value:"E"},{name:"Commercial license Class F",value:"F"}],
        value:"" // G
    },
    drld:{
        type:"date",
        title: "Date Licence Obtained",
        propertyName:"drive_licensed",
        middleware: "crmRecordMiddleware",
        validators: ["required"],
        value:"" // 20220215
    },
    tikts:{
        type:"object",
        model: ticketModel,
        title: `<i class="lni lni-ticket"></i>Ticket(s)`,
        addElement: `<i class="lni lni-ticket"></i></br>Add Ticket`,
        values:[]
    },
    clams:{
        type:"object",
        model: claimModel,
        title: `<i class="lni lni-stamp"></i>Claim(s)`,
        addElement: `<i class="lni lni-stamp"></i></br>Add Claim`,
        values:[]
    },
    lapss:{
        type:"object",
        model: lapseModel,
        title: `<i class="lni lni-alarm-clock"></i>Lapse(s)`,
        addElement: `<i class="lni lni-alarm-clock"></i></br>Add Lapse`,
        values:[]
    }
}


export default driverModel;